import PropTypes from 'prop-types';
import styled from 'styled-components';
import chunk from 'lodash.chunk';

import RichRelevanceProductsSingleRow from './RichRelevanceProductsSingleRow';

const Title = styled.h4`
  font-size: 1.4em;
  margin-top: 20px;
  padding-bottom: .5em;
  border-bottom: 1px solid #e5e5e5;
`;

const renderRichRelevanceProductsForMobileOrTablet = (productList, numberOfProductPerRow) => {
  const rows = chunk(productList, numberOfProductPerRow);

  return rows.map((row, i, thisArray) =>
    <RichRelevanceProductsSingleRow productList={row} key={row[0].id} showBordersOnBottom={i < thisArray.length - 1} />
  );
};

const RichRelevanceProductsMainContainer = ({ title, productList, deviceType }) => (
  <div>
    <Title>{title}</Title>
    {deviceType === 'mobile' && (
      renderRichRelevanceProductsForMobileOrTablet(productList, 2)
    )}
    {deviceType === 'tablet' && (
      renderRichRelevanceProductsForMobileOrTablet(productList, 3)
    )}
    {deviceType !== 'mobile' && deviceType !== 'tablet' && (
      <RichRelevanceProductsSingleRow productList={productList} />
    )}

  </div>
);

RichRelevanceProductsMainContainer.propTypes = {
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  title: PropTypes.string.isRequired,
  productList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    linkURL: PropTypes.string,
    imageURL: PropTypes.string,
    numberOfReviews: PropTypes.number,
    averageScore: PropTypes.number,
    productDescription: PropTypes.string,
    price: PropTypes.string,
    availableInStore: PropTypes.shape({
      available: PropTypes.bool,
      label: PropTypes.string
    }).isRequired,
    homeDelivery: PropTypes.shape({
      available: PropTypes.bool,
      label: PropTypes.string
    }).isRequired
  })).isRequired
};

export default RichRelevanceProductsMainContainer;
